export enum PAYMENT_METHOD {
  BANK_TRANSFER = 0,
  PAYPAL = 1,
  CASH = 2,
  ESHOP = 3,
  ONLINE_MERCHANT = 4,
  MAXICARE_PAYMENT = 5,
  PAYNAMICS = 6,
  PAYNAMICS_CREDIT_CARD = 7,
  PAYNAMICS_INSTALLMENT = 8,
  GCASH = 9
};
